// The two session-event contract strings.
//
// They live in their own module (rather than in the detector) because BOTH sides of the
// session_state split need them: the implementation (lib/session_state_detector.js, which only
// packs/global.js imports) dispatches/listens for them, and the shim (lib/session_state.js) must
// re-export them to consumers WITHOUT importing the implementation — which is the whole point of
// the shim. Declaring them in both places would invite exactly the drift a shared module prevents.
// They are ~60 bytes, so the copy that lands in each consumer bundle is free.

// In-page session-change broadcast (plans/2026-07-09--self-login-surface-session-announce.md).
// A `document`-level CustomEvent the detector dispatches on a REAL transition (login,
// logout, person-switch, silent expiry), carrying the new state in `detail` (an object
// when logged in, `null` when logged out). This follows the house global-broadcast idiom
// (helpers/dom_update_event.js: document.dispatchEvent + document.addEventListener) rather
// than the detector's bespoke subscribe/notify. Any in-page component (AccountPanel today;
// website / online-web-app login UIs in future) can react without a page refresh. It fires
// regardless of `emitToNative`, so a fan-out-poke-triggered re-check that reveals a change
// (emitToNative:false) still updates in-page UI. It does NOT fire on a no-op re-check.
export const SESSION_CHANGED_EVENT = "Person-sessionChanged";

// Cross-surface fan-out contract (plans/2026-07-09--cross-surface-session-sync.md).
// A payload-free DOM event the NATIVE host dispatches into EVERY live webview when
// it receives a Person-loggedIn/-loggedOut signal from any surface. It carries no
// identity — native is not the source of truth; it only says "re-read the cookie".
// The listener (nav.js) responds with check({ emitToNative: false }) so the fan-out
// stays strictly one-way (native → surfaces) with no echo. This string is the
// cross-repo contract — it MUST be byte-identical in the iOS and Android apps.
export const SESSION_RECHECK_EVENT = "Person-sessionMayHaveChanged";
